import { render, staticRenderFns } from "./Box1.vue?vue&type=template&id=577e41c9&scoped=true&"
var script = {}
import style0 from "./Box1.vue?vue&type=style&index=0&id=577e41c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577e41c9",
  null
  
)

export default component.exports